import { useIntl } from 'react-intl'
import theme from 'theme_'

import { homeDeviceInformationMessages as messages } from '../../messages'
import DeviceInformationCard from '../../components/DeviceInformationCard'
import { DeviceStatusColorProps } from '../types'

function GreenStatus({ statusString }: DeviceStatusColorProps) {
  const { formatMessage } = useIntl()

  return (
    <DeviceInformationCard
      title={formatMessage(messages.deviceConnectionStatusLabel)}
      value={statusString || formatMessage(messages.deviceStatusCardConnected)}
      color={theme.colors.successGreen}
      bgColor={theme.colors.successBack}
      order={1}
    />
  )
}

export default GreenStatus
